// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_incident_impact_enum */
var FermentationIncidentImpactEnum;
(function (FermentationIncidentImpactEnum) {
    FermentationIncidentImpactEnum["NONE"] = "NONE";
    FermentationIncidentImpactEnum["DEVIATION"] = "DEVIATION";
    FermentationIncidentImpactEnum["TERMINATED"] = "TERMINATED";
})(FermentationIncidentImpactEnum || (FermentationIncidentImpactEnum = {}));
;
export default FermentationIncidentImpactEnum;
/** Zod schema for fermentation_incident_impact_enum */
export const fermentationIncidentImpactEnum = z.nativeEnum(FermentationIncidentImpactEnum);
//# sourceMappingURL=FermentationIncidentImpactEnum.js.map